import React from 'react';
import { Select, MenuItem, SelectChangeEvent, FormControl } from '@mui/material';
import { usePerformanceReportingContext } from './PerformanceReportingContext';
import useAssignedModules from './_data_sources/useAssignedModules';

export default function AssignedModuleFilter() {
  const { orgId, childOrgId, assignedModule, setAssignedModule } = usePerformanceReportingContext();
  const { data: assignedModules } = useAssignedModules({ orgId, childOrgId });

  const handleAssignedModuleChange = (event: SelectChangeEvent<string>) => {
    setAssignedModule(event.target.value);
  };

  if (!assignedModules || assignedModules.length === 0) {
    return null;
  }

  return (
    <FormControl
      size='small'
      sx={{ p: 0 }}
    >
      <Select
        value={assignedModule || assignedModules[0]?.key || ''}
        onChange={handleAssignedModuleChange}
        displayEmpty
        sx={{
          minWidth: 200,
          backgroundColor: 'white',
          '& .MuiSelect-select': {
            py: 1,
          },
        }}
      >
        {assignedModules.map((module) => (
          <MenuItem
            key={module.key}
            value={module.key}
          >
            {module.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
